<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_761" data-name="Rectangle 761" width="127.887" height="126.936"
                  transform="translate(0 0)" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_865" data-name="Rectangle 865" width="380" height="678"/>
    <text id="Will_your_ideas_get_noticed_by_the_C-suite_" data-name="Will your ideas get noticed by
the C-suite?" transform="translate(39 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">Will your ideas get noticed by</tspan>
        <tspan x="0" y="28">the C-suite?</tspan>
    </text>
    <text id="_67_of_business_leaders_say_you_have_less_than" data-name="67% of business leaders say you have less than"
          transform="translate(39 121)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">67% of business leaders</tspan>
        <tspan x="0" y="46">say you have less than</tspan>
    </text>
    <text id="to_get_their_attention" data-name="to get their attention" transform="translate(39 420)" fill="#fff"
          font-size="24" font-family="Metric">
        <tspan x="0" y="18">to get their attention</tspan>
    </text>
    <text id="_30_sec" data-name="30 sec" transform="translate(39 342)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="0" y="66">30 sec</tspan>
    </text>
    <g id="Group_1476" data-name="Group 1476" transform="translate(-448 -20)">
        <g id="Group_1475" data-name="Group 1475" transform="translate(506 220)">
            <line id="Line_7889" data-name="Line 7889" y2="46.146" transform="translate(63.944 17.322)" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7890" data-name="Line 7890" transform="translate(75.934 107.916)" fill="none" stroke="#fff"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"/>
            <g id="Group_1474" data-name="Group 1474">
                <g id="Group_1473" data-name="Group 1473" clip-path="url(#clip-path)">
                    <path id="Path_14753" data-name="Path 14753" d="M75.934,107.916q2.366-.393,4.573-.98" fill="none"
                          stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"
                          stroke-dasharray="0 11.344"/>
                    <path id="Path_14754" data-name="Path 14754"
                          d="M86.8,104.759c15.877-6.908,24.06-22.337,24.06-41.574,0-21.034-10.4-38.69-29.349-43.565"
                          fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"
                          stroke-dasharray="0 11.344"/>
                    <line id="Line_7891" data-name="Line 7891" transform="translate(75.934 18.59)" fill="none"
                          stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"/>
                    <path id="Path_14755" data-name="Path 14755"
                          d="M1,63.468C1,28.968,29.181,1,63.944,1s62.943,27.968,62.943,62.468-28.181,62.468-62.943,62.468S1,97.968,1,63.468Z"
                          fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_14756" data-name="Path 14756"
                          d="M38.271,25.037a1.461,1.461,0,1,1,2,.535,1.461,1.461,0,0,1-2-.535" fill="#008ed2"/>
                    <path id="Path_14757" data-name="Path 14757"
                          d="M22.592,43.078a1.461,1.461,0,1,1,2-.535,1.462,1.462,0,0,1-2,.535" fill="#008ed2"/>
                    <path id="Path_14758" data-name="Path 14758"
                          d="M18.034,66.541A1.462,1.462,0,1,1,19.5,65.08a1.461,1.461,0,0,1-1.461,1.461" fill="#008ed2"/>
                    <path id="Path_14759" data-name="Path 14759"
                          d="M25.818,89.14a1.461,1.461,0,1,1,.535-2,1.461,1.461,0,0,1-.535,2" fill="#008ed2"/>
                    <path id="Path_14760" data-name="Path 14760"
                          d="M43.859,104.819a1.461,1.461,0,1,1-.535-2,1.462,1.462,0,0,1,.535,2" fill="#008ed2"/>
                    <path id="Path_14761" data-name="Path 14761"
                          d="M67.322,109.378a1.461,1.461,0,1,1-1.461-1.461,1.461,1.461,0,0,1,1.461,1.461"
                          fill="#008ed2"/>
                    <path id="Path_14762" data-name="Path 14762"
                          d="M67.322,109.378a1.461,1.461,0,1,1-1.461-1.461A1.461,1.461,0,0,1,67.322,109.378Z"
                          fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
                </g>
            </g>
        </g>
    </g>
</svg>
